import { Tabs, TabsList, TabsTrigger } from '@ibsys/kit';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { DownloadTemplateEntityType } from '@/entities/download-template';
import { PageContainer } from '@/shared/ui';
import { DownloadTemplatesList } from './DownloadTemplatesList';
import { DownloadTemplateUploadForm } from './DownloadTemplateUploadForm';
import { DownloadTemplateVariablesHelp } from './DownloadTemplateVariablesHelp';

/** Сущности документов в порядке показа вкладок */
const ENTITY_TYPES: DownloadTemplateEntityType[] = ['TRANSCRIPT', 'EXPERT_REPORT'];

/**
 * Раздел «Шаблоны»: единственное место, где шаблоны скачиваемых документов заводят и убирают.
 * Пользователь работает с одной сущностью за раз — активная вкладка задаёт сущность всех
 * запросов страницы: её загрузки, её перечня и её подсказки по переменным.
 */
export const DownloadTemplatesPage: FC = () => {
  const { t } = useTranslation('downloadTemplates');
  const [entityType, setEntityType] = useState<DownloadTemplateEntityType>('TRANSCRIPT');

  const handleTabChange = (value: string) => setEntityType(value as DownloadTemplateEntityType);

  return (
    <PageContainer className="flex flex-col gap-6">
      <h1 className="text-2xl font-bold">{t('pageTitle')}</h1>

      <Tabs value={entityType} onValueChange={handleTabChange}>
        <TabsList>
          {ENTITY_TYPES.map((type) => (
            <TabsTrigger key={type} value={type}>
              {t(`entityType.${type}`)}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <section className="flex flex-col gap-3">
        <h2 className="font-medium">{t('upload.title')}</h2>
        <DownloadTemplateUploadForm key={entityType} entityType={entityType} />
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="font-medium">{t('list.title')}</h2>
        <DownloadTemplatesList entityType={entityType} />
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="font-medium">{t('variables.title')}</h2>
        <DownloadTemplateVariablesHelp entityType={entityType} />
      </section>
    </PageContainer>
  );
};
